const DEFAULT_COUNTRY_CODE = '0';
const NORMALIZED_MDN_LENGTH = 10;
const MAX_NORMALIZED_COUNTRY_CODE_LENGTH = 3;

export default class Mdn {
    private localNumber: string;
    private countryCode: string;

    constructor(localNumber: string, countryCode: string) {
        this.localNumber = localNumber;
        this.countryCode = countryCode;
    }

    public getFullFormattedMdn(): string {
        return `${this.countryCode}${this.localNumber}`;
    }

    public getLocalNumber(): string {
        return this.localNumber;
    }

    public isDefaultCountryCode(): boolean {
        return this.countryCode === DEFAULT_COUNTRY_CODE;
    }
    static isValidMdn(mdn: string): boolean {
        const phoneRegex = /^[0-9+\-() ]*$/;
        return phoneRegex.test(mdn);
    }
    public static parseMdn(mdn: string): Mdn | undefined {
        if (!mdn) return;
        if (!Mdn.isValidMdn(mdn)) return;
        const mdnStringOnlyDigits = mdn.replace(/\D/g, '');
        // Validate length
        if (mdnStringOnlyDigits.length < NORMALIZED_MDN_LENGTH) return;
        if (mdnStringOnlyDigits.length > NORMALIZED_MDN_LENGTH + MAX_NORMALIZED_COUNTRY_CODE_LENGTH) return;

        // extract the last 10 digits
        const localNumber = mdnStringOnlyDigits.slice(-NORMALIZED_MDN_LENGTH);
        // extract the country code
        let countryCode = mdnStringOnlyDigits.slice(0, mdnStringOnlyDigits.length - NORMALIZED_MDN_LENGTH);
        // if no country code, use default country code
        if (countryCode.length === 0) {
            countryCode = DEFAULT_COUNTRY_CODE;
        }
        return new Mdn(localNumber, countryCode);
    }

    public toString(): string {
        return this.getFullFormattedMdn();
    }
}
